import React from 'react';

const SKELETON_COUNT = 12;

const CountriesPage = ({
  countries,
  filteredCountries,
  countrySearchTerm,
  loading,
  syncStatus,
  countryPlayCounts,
  getCountryFlag,
  onCountrySelect,
  onSearchChange,
  onSearchKeyPress,
  onClearSearch,
  onRefresh,
}) => {
  const displayedCountries = countrySearchTerm ? filteredCountries : countries;
  const isInitialLoad = loading && countries.length === 0;

  return (
    <div className="countries-page animate-fade-in">
      {/* Header */}
      <div className="page-header">
        <h1 className="page-title">Discover Radio</h1>
        <p className="page-subtitle">Choose a country to explore live radio stations</p>
      </div>

      {/* Search */}
      <div className="search-bar">
        <div className="search-input-wrapper">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            className="search-input"
            placeholder="Search countries…"
            value={countrySearchTerm}
            onChange={onSearchChange}
            onKeyDown={onSearchKeyPress}
            aria-label="Search countries"
          />
          {countrySearchTerm && (
            <button
              className="search-clear-btn"
              onClick={onClearSearch}
              aria-label="Clear search"
            >
              ✕
            </button>
          )}
        </div>
      </div>

      {/* Sync notice */}
      {syncStatus?.sync_status === 'running' && (
        <div className="sync-status-banner">
          <div className="loading-spinner" style={{ width: 16, height: 16, borderWidth: 2 }} />
          Syncing stations from radio-browser.info…
        </div>
      )}

      {/* Content */}
      {isInitialLoad ? (
        <div className="skeleton-grid">
          {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
            <div key={i} className="skeleton-card" />
          ))}
        </div>
      ) : displayedCountries.length > 0 ? (
        <div className="countries-grid">
          {displayedCountries.map((country, index) => (
            <div
              key={`country-${country.id || index}`}
              className="country-card"
              onClick={() => onCountrySelect(country)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onCountrySelect(country);
                }
              }}
              aria-label={`${country.name}, ${country.station_count || 0} stations`}
            >
              <div className="country-flag">{getCountryFlag(country.iso_code)}</div>
              <div className="country-name">{country.name}</div>
              <div className="country-meta">
                {country.station_count ? (
                  <span className="country-badge">{country.station_count} stations</span>
                ) : (
                  <span className="country-meta">
                    {countryPlayCounts[country.name]
                      ? `${countryPlayCounts[country.name]} plays`
                      : 'Explore'}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : countrySearchTerm ? (
        <div className="empty-state">
          <div className="empty-state-icon">🔍</div>
          <div className="empty-state-title">No results for "{countrySearchTerm}"</div>
          <div className="empty-state-desc">Try a different country name</div>
        </div>
      ) : (
        <div className="empty-state">
          <div className="empty-state-icon">🌍</div>
          <div className="empty-state-title">No countries available yet</div>
          <div className="empty-state-desc">
            {syncStatus?.sync_status === 'running'
              ? 'Stations are syncing, this will be ready shortly.'
              : 'Data may still be loading from our servers.'}
          </div>
          <button
            className="refresh-btn"
            onClick={onRefresh}
            disabled={loading}
            style={{ marginTop: 'var(--space-4)' }}
          >
            {loading ? 'Refreshing…' : '↻ Refresh'}
          </button>
        </div>
      )}
    </div>
  );
};

export default CountriesPage;
